/* eslint-disable no-param-reassign */
import { MessageStatus, CLIENT_ORIGIN_WS_EVENTS } from '~/constants';

import { getPrimus } from '~/utils/primus';
import { setSelectedConversation } from '~/actions/conversations';

import {
  editCustomer as editCustomerRequest,
  getCustomerByIdentifier,
} from '../api/customers';

export const readMessage = (message) => () => {
  const primus = getPrimus();

  primus.emit(CLIENT_ORIGIN_WS_EVENTS.SET_MESSAGE_STATUS, {
    _id: message.id,
    message_id: message.message_id,
    status: MessageStatus.READ,
  });
};

export const editCustomer = (payload) => async (dispatch, getState) => {
  const customerID = payload._id || payload.id;

  await editCustomerRequest(customerID, payload);

  const updatedCustomer = await getCustomerByIdentifier(customerID);

  const { selectedConversation } = getState().conversations;

  if (selectedConversation?.id === customerID) {
    const newSelectedConversation = {
      ...selectedConversation,
      ...updatedCustomer,
    };

    dispatch(
      setSelectedConversation({
        selectedConversation: newSelectedConversation,
      })
    );
  }
};
